import React from 'react';
import PropTypes from 'prop-types';
import './index.css';

const propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

const Hyperlink = ({ href, children }) => {
  return (
    <a className="Hyperlink u__normalize_anchor" href={href}>
      {children}
    </a>
  );
};

Hyperlink.propTypes = propTypes;

export default Hyperlink;



// WEBPACK FOOTER //
// ../ui-components/components/Hyperlink/index.jsx